<template>
  <div class="date-picker">
    <div class="flex justify-start items-center gap-4">
      <div class="flat-pickr-wrapper relative">
        <feather-icon
          class="calendar-icon"
          icon="CalendarIcon"
          svgClasses="h-4 w-4"
          @click.stop="onClearButtonClick"
        />
        <feather-icon
          v-if="showClear"
          class="clear-icon"
          icon="XIcon"
          svgClasses="h-4 w-4"
          @click.stop="onClearButtonClick"
        />
        <feather-icon
          class="arrow-icon"
          svgClasses="h-4 w-4"
          icon="ChevronDownIcon"
        />
        <flat-pickr
          class="crew-date-flat-picker start-date"
          v-model="selectedDate"
          :placeholder="placeholder"
          :config.sync="configTimePicker"
          ref="selectedDatePicker"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const FLAT_PICKR_CLASS_NAME = "flatpickr-calendar";
const DATE_FLAT_PICKR_CLASS_NAME = "crew-date-flat-picker";
const STYLE_OVERWRITE = "style-overwrite";

export default {
  name: "DatePicker",
  props: {
    applyCallBack: { type: Function, required: false },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "2022/01/01〜",
    },
    dateFormat: {
      type: String,
      required: false,
      default: "Y/m/d〜",
    },
    value: {
      type: Date,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [ColorMixin],
  components: {
    flatPickr,
  },
  watch: {
    value: {
      handler: function(val, oldVal) {
        if (val != oldVal) {
          this.selectedDate = val;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      lastSelectedDate: null,
      selectedDate: null,
      configTimePicker: {
        enableTime: false,
        dateFormat: this.dateFormat,
        onClose: date => {
          this.$emit("update:value", date[0]);
        },

        minDate: null,
        maxDate: null,
        locale: Japanese,
        monthSelectorType: "static",
      },
    };
  },
  computed: {
    showClear() {
      return this.clearable && this.value != null;
    },
  },

  methods: {
    onClearButtonClick() {
      this.$emit("update:value", null);
    },
  },
  mounted() {
    // flatpickrに独自スタイルを当てるためにclass付与
    document.querySelectorAll(`.${FLAT_PICKR_CLASS_NAME}`).forEach(fc => {
      fc.classList.add(DATE_FLAT_PICKR_CLASS_NAME, STYLE_OVERWRITE);
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.date-picker {
  .calendar-icon {
    position: absolute;
    left: 10px;
    top: 11px;
    pointer-events: none;
  }
  .arrow-icon {
    position: absolute;
    right: 12px;
    top: 11px;
    pointer-events: none;
  }
  .clear-icon {
    position: absolute;
    right: 30px;
    top: 11px;
    cursor: pointer;
  }
  ::placeholder {
    color: rgb(186, 186, 186);
    opacity: 1; /* Firefox */
  }

  ::-ms-input-placeholder {
    /* Edge 12 -18 */
    color: rgb(186, 186, 186);
  }
  .flatpickr-input {
    padding-left: 34px;
  }
  .flat-pickr-wrapper {
    .calendar-icon {
      font-size: 15px;
      top: 50%;
      left: 12px;
      transform: translate(0%, -50%);
    }
    .flatpickr-input {
      border: solid 1px $aisea-light-gray;
      width: 160px;
    }
  }
  .flatpickr-input.active {
    border: 1px solid $aisea-blue !important;
  }
}

.flatpickr-calendar {
  &.crew-date-flat-picker {
    .flatpickr-current-month {
      display: flex;
      justify-content: center;
      align-items: center;
      align-items: baseline;
      gap: 30px;

      span.cur-month {
        color: #626262;
      }
    }
    .flatpickr-day {
      &.selected,
      &.startRange,
      &.endRange,
      &.selected.inRange,
      &.startRange.inRange,
      &.endRange.inRange,
      &.selected:focus,
      &.startRange:focus,
      &.endRange:focus,
      &.selected:hover,
      &.startRange:hover,
      &.endRange:hover,
      &.selected.prevMonthDay,
      &.startRange.prevMonthDay,
      &.endRange.prevMonthDay,
      &.selected.nextMonthDay,
      &.startRange.nextMonthDay,
      &.endRange.nextMonthDay {
        background: $aisea-blue !important;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: $aisea-blue !important;
      }
    }
  }
}
</style>
